import { RefObject, useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

export const useScrollToOnError = (scrollable: RefObject<HTMLDivElement>, name: string) => {
  const formik = useFormikContext();
  const [prevSubmitCount, setPrevSubmitCount] = useState(formik.submitCount);
  const firstErrorKey = Object.keys(formik.errors)[0];

  useEffect(() => {
    const isScrollIntoViewSupported = 'scrollIntoView' in document.documentElement;

    if (prevSubmitCount !== formik.submitCount && !formik.isValid) {
      if (scrollable.current && firstErrorKey === name && isScrollIntoViewSupported) {
        scrollable.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      setPrevSubmitCount(formik.submitCount);
    }
  }, [formik.submitCount, formik.isValid]);
};
